module.exports = __webpack_public_path__ + "img/symbol_2.aac1ca35.png";